export const PATIENT_PAYMENT_DEFAULT = Object.freeze({
  SELF_PAY: 'Self Pay',
  PRIMARY_INSURANCE: 'Primary',
});
